<template>
  <div class="pull-refresh-container">
    <!-- 下拉刷新提示区域 -->
    <div class="refresh-tip" :class="{ active: isRefreshing }">
      <i class="el-icon-loading" v-if="isRefreshing"></i>
      <span>{{ refreshText }}</span>
    </div>

    <!-- 内容滚动区域 -->
    <div class="scroll-wrapper" ref="scrollWrapper">
      <div class="scroll-content">
        <slot></slot>
        <!-- 上拉加载提示区域 -->
        <div class="loadmore-tip" :class="{ active: isLoadingMore }">
          <i class="el-icon-loading" v-if="isLoadingMore"></i>
          <span>{{ loadmoreText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'

export default {
  props: {
    // 是否开启下拉刷新
    pullDownRefresh: {
      type: [Boolean, Object],
      default: true
    },
    // 是否开启上拉加载
    pullUpLoad: {
      type: [Boolean, Object],
      default: true
    }
  },
  data() {
    return {
      scroll: null,
      isRefreshing: false,
      isLoadingMore: false,
      refreshText: this.$t("pull"),
      loadmoreText: this.$t("noMore")
    }
  },
  mounted() {
    this.initScroll()
  },
  methods: {
    initScroll() {
      this.scroll = new BScroll(this.$refs.scrollWrapper, {
        probeType: 3,
        click: true,
        bounce: {
          top: true,
          bottom: true
        },
        pullDownRefresh: this.pullDownRefresh ? {
          threshold: 50,
          stop: 0
        } : false,
        pullUpLoad: this.pullUpLoad ? {
          threshold: -50
        } : false
      })

      // 下拉刷新事件
      this.scroll.on('pullingDown', () => {
        console.log('pulling down')
        this.$emit('refresh', this.finishRefresh)
      })

      this.scroll.on('scroll', (pos) => {
        //console.log('scroll', pos)
        if (pos.y > 0) {
          this.refreshText = this.$t("release")
          this.isRefreshing = true
        } else if (pos.y <-10) {
          this.isLoadingMore = true
          this.refreshText =  this.$t("pull")
        }else{
          this.refreshText = this.$t("noMore")
        }
      })

      // 上拉加载事件
      this.scroll.on('pullingUp', () => {
        this.$emit('loadmore', this.finishLoadMore)
      })

      // 下拉刷新回调
      this.scroll.on('scrollEnd', (pos) => {
        console.log(pos)
        if(this.isRefreshing){
          this.isRefreshing = false
        }
        if(this.isLoadingMore){
          this.isLoadingMore = false
        }
      })
    },
    finishRefresh() {
      this.refreshText = this.$t("release")
      this.scroll.finishPullDown()
      this.scroll.refresh()
    },
    finishLoadMore() {
      this.loadmoreText = this.$t("pull")
      this.scroll.finishPullUp()
      this.scroll.refresh()
    },
    refresh() {
      this.scroll && this.scroll.refresh()
    }
  },
  unmounted() {
    this.scroll && this.scroll.destroy()
  }
}
</script>

<style scoped>
.pull-refresh-container {
  height: 75vh;
  overflow: hidden;
  position: relative;
}

.scroll-wrapper {
  height: 100%;
  overflow: hidden;
}

.refresh-tip {
  position: absolute;
  top: -50px;
  left: 0;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
  transition: all 0.3s;
}

.refresh-tip.active {
  top: 0px;
}

.loadmore-tip {
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
}

.loadmore-tip.active {
  color: #409EFF;
}
</style>
